import Tooltip from "@8x8/oxygen-tooltip";
import { CheckCircleIcon } from "@8x8/oxygen-icon";
import CloseCircleIcon from "@8x8/oxygen-icon/icons/CloseCircleIcon";
import styled from "styled-components";
import { COLORS } from "@/react/theme/constants";

const NoValueLabel = styled.div`
  color: ${COLORS.secondary};
  font-style: italic;
`;

export const TenantValueIndicator = ({ value }) => {
  if (!value) return <NoValueLabel>No value</NoValueLabel>;

  if (value === "enabled")
    return (
      <Tooltip title={"Enabled"} orientation={"left-start"}>
        <CheckCircleIcon data-test-id={"enabled-icon"} color={"green"} />
      </Tooltip>
    );

  if (value === "disabled")
    return (
      <Tooltip title={"Disabled"} orientation={"left-start"}>
        <CloseCircleIcon data-test-id={"disabled-icon"} color={"red"} />
      </Tooltip>
    );

  return value;
};
